import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import "roboto-fontface/css/roboto/roboto-fontface.css";
import "@fortawesome/fontawesome-free/css/all.css";
import Firebase from "@/firebase";
import Ionic from "@ionic/vue";
import "@ionic/core/css/ionic.bundle.css";

Vue.use(Ionic);
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  created() {
    Firebase.auth().onAuthStateChanged(user => {
      if (user) {
        this.$store.dispatch("init");
        this.$router.push("/");
      } else {
        this.$router.push("/login");
      }
    });
  },
  render: h => h(App)
}).$mount("#app");
